import { ClientHandler } from '../../../types';
import { CreativityType } from '../../../types/banner';

import { getPlayerVsPlayerHelpers } from '../../../constants/clients/DISNEY/espn/player-vs-player/helpers';
import { getESPNVSHelpers } from '../../../constants/clients/DISNEY/espn/vs-unified/helpers';
import { getRugbyUrbaMiniHelpers } from '../../../constants/clients/DISNEY/espn/rugby-urba-miniatura/helpers';

export const disneyHandler: ClientHandler = {
  transformBannerType: (formData, baseType) => {
    // Player vs Player
    if (baseType === 'espn/espn-vs/futbol') {
      return getPlayerVsPlayerHelpers().buildBannerType(formData) as CreativityType;
    }

    // VS Unified
    if (baseType === 'espn/espn-vs') {
      return getESPNVSHelpers().buildESPNBannerType(formData) as CreativityType;
    }
    return baseType;
  },

  applyFieldLogic: (fieldKey, value, formData) => {
    const creativityType = formData._creativityType;

    // Player vs Player
    if (creativityType === 'espn/espn-vs/futbol') {
      return getPlayerVsPlayerHelpers().applyFieldLogic(fieldKey, value, formData);
    }

    // Rugby Miniatura
    if (creativityType === 'espn/espn-vs/rugby/urba-top-12/miniatura') {
      return getRugbyUrbaMiniHelpers().applyFieldLogic(fieldKey, value, formData);
    }

    // VS Unified
    if (creativityType === 'espn/espn-vs') {
      return getESPNVSHelpers().applyFieldLogic(fieldKey, value, formData);
    }

    return {};
  },

  cleanFormData: (formData, creativityType) => {
    // Player vs Player
    if (creativityType === 'espn/espn-vs/futbol') {
      return getPlayerVsPlayerHelpers().cleanFormData(formData);
    }

    // Rugby Miniatura
    if (creativityType === 'espn/espn-vs/rugby/urba-top-12/miniatura') {
      return getRugbyUrbaMiniHelpers().cleanFormData(formData);
    }

    // VS Unified
    if (creativityType === 'espn/espn-vs') {
      return getESPNVSHelpers().cleanFormData(formData);
    }

    const { title, _creativityType, ...config } = formData;
    return config;
  },

  shouldShowField: (fieldKey, formData, creativityType) => {
    // Rugby Miniatura
    if (creativityType === 'espn/espn-vs/rugby/urba-top-12/miniatura') {
      return getRugbyUrbaMiniHelpers().shouldShowField(fieldKey, formData);
    }

    // VS Unified
    if (creativityType === 'espn/espn-vs') {
      return getESPNVSHelpers().shouldShowField(fieldKey, formData);
    }

    return true;
  },

  getDynamicOptions: (fieldKey, formData, baseOptions) => {
    const creativityType = formData._creativityType;

    // Player vs Player
    if (creativityType === 'espn/espn-vs/futbol') {
      return getPlayerVsPlayerHelpers().getDynamicOptions(fieldKey, formData, baseOptions);
    }

    // Rugby Miniatura
    if (creativityType === 'espn/espn-vs/rugby/urba-top-12/miniatura') {
      return getRugbyUrbaMiniHelpers().getDynamicOptions(fieldKey, formData, baseOptions);
    }

    // VS Unified
    if (creativityType === 'espn/espn-vs') {
      return getESPNVSHelpers().getDynamicOptions(fieldKey, formData, creativityType, baseOptions);
    }

    return baseOptions;
  },

  getBannerMetadata: banner => {
    if (!banner || !banner.bannerType) {
      return null; // Retornar null para que use el fallback
    }

    const creativityType = banner.bannerType;

    if (creativityType.startsWith('espn/espn-vs/')) {
      return getPlayerVsPlayerHelpers().getBannerMetadata(banner);
    }

    return null;
  }
};
